import styled from 'styled-components';

export const Content = styled.div``;

export const Name = styled.h3`
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.02em;
  text-align: left;
  color: #0a214280;
`;

export const Div = styled.div`
  &.active {
    color: var(--primary-green);
  }
  &.inactive {
    color: #ff646480;
  }
  &.captal {
    text-transform: capitalize;
  }
`;

export const Head = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #eef1f6;
  padding: 7px 10px;
  border-radius: 12px;
  font-size: 14px;
  color: #8a93ac;
  font-weight: 500;
`;

export const FilterButoons = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const Button = styled.button`
  font-family: Poppins;
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
  letter-spacing: 0em;
  text-align: center;
  color: var(--white);
  background: #8a93ac;
  min-width: 68px;
  border: none;
  height: 28px;
  border-radius: 8px;
  padding: 0 8px;

  &.active {
    background: var(--primary-dark-two);
  }
`;

export const Icon = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 40px;
  /* padding: 10px; */
`;

export const Image = styled.img`
  max-width: 100%;
  padding: 10px;
`;

export const Detail = styled.div`
  min-height: 400px;
  flex-direction: column;
  justify-content: center;
`;

export const Item = styled.div`
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding: 10px 0;
`;

export const Title = styled.h4`
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 0em;
  margin-bottom: 10px;
  color: #030e30;
`;

export const MainTitle = styled.h4`
  font-size: 16px;
  font-weight: 500;
  line-height: 21px;
  letter-spacing: 0em;
  margin-bottom: 10px;
  color: #030e30;
`;

export const Text = styled.p`
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  letter-spacing: 0em;
`;

export const Grid = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
